import { ExperiencesResponse, IAddressResponse } from '@cemex-core/cmx-api';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import {
  JobsiteActions,
  LS_JOBSITE_SET,
  LS_LOAD,
  LS_LOAD_ADDRESS,
  LS_LOAD_COMPLETE,
  LS_LOAD_INITIAL_STATE,
  LS_RESET,
  LS_SALES_AREA_LOAD_COMPLETE,
  LS_LOAD_ADDRESS_SUCCESS,
  LS_JOBSITE_MODAL,
  LS_LOAD_EXPERIENCE_SUCCESS,
  LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS_SUCCESS,
} from '../../actions/jobsite-actions/jobsite.actions';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { IJobsiteSalesAreas } from '../../models/order-management/jobsite-sales-area.model';
import { Jobsite } from '../../models/order-management/jobsite.model';
import {
  LocationSpecificationActions,
  LocationSpecificationActionTypes,
} from '../../actions/location-specifications.actions';

/**
 * A state-object which describes the jobsite selector control in the OT workflow, and also
 * the item selected from those available.
 */
export interface IJobsiteState {
  loaded: boolean;
  loading: boolean;
  jobsites: Jobsite[];
  required: boolean;
  disabled: boolean;
  visible: boolean;
  selected: Jobsite;
  previouslySelected: Jobsite;
  salesArea: IJobsiteSalesAreas[];
  selectedSalesArea: IJobsiteSalesAreas;
  selectedJobsiteAddress: IAddressResponse;
  hasBlockedJobsites: boolean;
  openModalJobsite: boolean;
  experience?: ExperiencesResponse;
  purchaseOrderMaskPatterns: string[];
  pointOfDelivery?: any[];
}

export const initialState: IJobsiteState = {
  required: false,
  disabled: false,
  visible: false,
  loaded: false,
  loading: false,
  jobsites: [],
  selected: undefined,
  previouslySelected: undefined,
  salesArea: [],
  selectedSalesArea: undefined,
  selectedJobsiteAddress: undefined,
  hasBlockedJobsites: false,
  openModalJobsite: false,
  experience: undefined,
  purchaseOrderMaskPatterns: [],
};

export function jobsiteReducer(
  state = initialState,
  action: JobsiteActions | OrderBuilderActions | LocationSpecificationActions,
): IJobsiteState {
  switch (action.type) {
    case LS_LOAD_INITIAL_STATE: {
      if (action.payload) {
        const jobsiteInitialState: ILocationConfigUnit = action.payload;
        return {
          ...state,
          disabled: jobsiteInitialState.disabled,
          required: jobsiteInitialState.required,
          visible: jobsiteInitialState.visible,
        } as IJobsiteState;
      }
      return {
        ...initialState,
      };
    }
    case LS_LOAD: {
      return {
        ...state,
        loading: true,
        loaded: false,
      } as IJobsiteState;
    }
    case LS_LOAD_COMPLETE: {
      const shipmentLocations: Jobsite[] = action.payload.jobsites.filter(jobsite => {
        return jobsite.block.orderBlock === false;
      });
      const hasBlockedJobsites = shipmentLocations.length < action.payload.jobsites.length;
      return {
        ...state,
        loaded: true,
        loading: false,
        jobsites: shipmentLocations,
        hasBlockedJobsites,
      } as IJobsiteState;
    }
    case LS_JOBSITE_SET: {
      return {
        ...state,
        loaded: true,
        stdLot: null,
        previouslySelected: state.selected,
        selected: action.payload,
      } as IJobsiteState;
    }
    case LS_SALES_AREA_LOAD_COMPLETE: {
      const salesAreas = action.payload;
      return {
        ...state,
        salesArea: salesAreas.salesAreas.jobsiteSalesAreas,
        selectedSalesArea: salesAreas.salesAreas.jobsiteSalesAreas[0],
      } as IJobsiteState;
    }
    case RESET_BUILDER:
    case LS_RESET: {
      return {
        ...initialState,
      };
    }
    case LS_LOAD_ADDRESS: {
      return state;
    }
    case LS_LOAD_ADDRESS_SUCCESS: {
      const address = action.payload;
      return {
        ...state,
        selectedJobsiteAddress: address,
      } as IJobsiteState;
    }
    case LS_LOAD_EXPERIENCE_SUCCESS: {
      const experience = action.payload.experiencesResponse;
      return {
        ...state,
        experience: experience,
      } as IJobsiteState;
    }
    case LS_JOBSITE_MODAL: {
      const openModal = action.payload.openModal;
      return {
        ...state,
        openModalJobsite: openModal,
      } as IJobsiteState;
    }

    case LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS_SUCCESS: {
      const purchaseOrderMaskPatterns = _safe(() => action.payload.purchaseOrderMaskPatterns, []);
      return {
        ...state,
        purchaseOrderMaskPatterns: purchaseOrderMaskPatterns,
      } as IJobsiteState;
    }

    case LocationSpecificationActionTypes.SET_LOCATION_SPECIFICATION_FROM_MODIFY: {
      const jobsiteState = action.payload.jobsite;
      return {
        ...jobsiteState,
      } as IJobsiteState;
    }
    default: {
      return state;
    }
  }
}
